import React from 'react';
import PageHero from '../components/PageHero';
import KnowUs from '../components/KnowUs';
import Ethics from '../components/Ethics';
import Director from '../components/Director';

const AboutUs = () => {
    return (
        <>
            <PageHero title="A warm, family-run nursery where Hygge-inspired comfort, curiosity, and creativity come together." />
            <KnowUs />
            <Ethics />
            <Director />
        </>
    );
};

export default AboutUs;
